// Zone type names on screen. The English names ('Product Zone', …) are DATA: they
// come from the database, sit in colour maps and are compared in code, so they never
// change. Only what the reader SEES goes through here. English shows the same name
// as always; Dutch follows docs/reference/dutch_glossary.md §10.
import { i18n } from './index.js'
import { detection_zone_colors_by_typeid } from '@/constants.js'

const ID_BY_NAME = {
  'Entrance Zone': 1, 'Exit Zone': 2, 'Combined Entrance Exit Zone': 3,
  'Checkout Waiting Zone': 4, 'Checkout Interaction Zone': 5, 'Product Zone': 6,
  'Demo Zone': 7, 'Display Zone': 8, 'Info Zone': 9, 'Service Zone': 10, 'Pick Up Zone': 11,
  'Info Waiting Zone': 12, 'Service Waiting Zone': 13, 'Pick Up Waiting Zone': 14,
  'Info Desk Zone': 15, 'Service Desk Zone': 16, 'Pick Up Desk Zone': 17, 'Cash Register Zone': 999,
}

// zoneTypeLabel(6) / zoneTypeLabel('Product Zone') -> 'Product Zone' | 'Productzone'.
// Unknown types show as given.
export function zoneTypeLabel(idOrName) {
  const id = typeof idOrName === 'number' || /^\d+$/.test(String(idOrName))
    ? Number(idOrName) : ID_BY_NAME[idOrName]
  if (id == null) return idOrName
  const key = `zoneTypes.byId.${id}`
  return i18n.global.te(key) ? i18n.global.t(key) : idOrName
}

export const zoneTypeIds = Object.keys(detection_zone_colors_by_typeid).map(Number)
